import React from 'react';
import classnames from 'classnames/bind';
import { ChatAgentButtonBase } from '../../../../../../../components/ChatAgent/components/ChatAgentButtonBase/ChatAgentButtonBase';
import { useReportComfortableViewParam } from '../../../hooks/useReportComfortableViewParam';
import styles from './fixWithAiButton.module.scss';

const classNameBuilder = classnames.bind(styles);

export const FixWithAiButton = ({ data }) => {
    const [isComfortableViewEnabled] = useReportComfortableViewParam();

    return (
        <div
            className={classNameBuilder('container', {
                'comfortable-view': isComfortableViewEnabled,
            })}
        >
            <ChatAgentButtonBase
                id="Fix with AI"
                messageId="abby.creative.rejection"
                eventData={{
                    creative: data,
                }}
            />
        </div>
    );
};
